import { Fields } from 'types/table';
import { applyMasks } from 'utils/masksManager';

export const getAnimalFields = async (field: any, selectedFazenda: any): Promise<Fields[]> => {
  const maskedField = applyMasks(field);

  return [
    {
      name: 'codFazenda',
      label: 'codFazenda',
      type: 'hidden',
      defaultValue: selectedFazenda.codFazenda,
    },
    {
      name: 'brinco',
      label: 'Brinco',
      type: 'text',
      defaultValue: field?.brinco,
      sm: 12,
      md: 4,
      isRequired: true,
    },
    {
      name: 'rfid',
      label: 'Brinco Eletrônico',
      type: 'text',
      defaultValue: maskedField?.rfid,
      sm: 12,
      md: 4,
    },
    {
      name: 'nome',
      label: 'Nome',
      type: 'text',
      defaultValue: field?.nome,
      sm: 12,
      md: 4,
    },
    {
      name: 'observacao',
      label: 'Observação',
      type: 'observacao',
      defaultValue: field?.observacao,
      sm: 12,
      md: 12,
    },
  ];
};
